import { call, delay, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { AUTH_LOAD_USER, LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { loginError, loginSuccess, logoutUserSuccess } from "./actions"

import { postLogin } from "helpers/services/auth"
import { getUserByEmail } from "helpers/services/user"
import {
  loadUserSuccess,
  loadUserError,
  resetSearchTrackingFlag,
} from "store/actions"
import { userConstants } from "constants/user"

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, {
      email: user.email,
      password: user.password,
    })

    if (response.success) {
      delete response.user.password
      yield put(loginSuccess(response.user))
      yield put(loadUserSuccess(response.user))
      yield put(resetSearchTrackingFlag())
      localStorage.setItem(
        userConstants.STORAGE.ACOUNT,
        JSON.stringify(response.user)
      )

      localStorage.setItem(userConstants.STORAGE.TOKEN, response.token)
      history.push("/search-tracking")
    } else {
      yield put(loginError(response.message))
    }
  } catch (error) {
    yield put(loginError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem(userConstants.STORAGE.ACOUNT)
    localStorage.removeItem(userConstants.STORAGE.TOKEN)
    history.push("/login")
  } catch (error) {
    yield put(loginError(error))
  }
}

function* loadUserOnSaga({ payload: { history, redirect } }) {
  try {
    if (!localStorage.getItem(userConstants.STORAGE.ACOUNT)) {
      localStorage.removeItem(userConstants.STORAGE.ACOUNT)
      if (redirect) history.push("/login")
    } else {
      const email = JSON.parse(
        localStorage.getItem(userConstants.STORAGE.ACOUNT)
      ).email
      yield delay(1000)
      const response = yield call(getUserByEmail, email)
      if (response.success) {
        delete response.user.password
        localStorage.setItem(
          userConstants.STORAGE.ACOUNT,
          JSON.stringify(response.user)
        )
        localStorage.removeItem(userConstants.STORAGE.IS_INVALID_TOKEN)
        yield put(loadUserSuccess(response.user))
      } else {
        yield put(loadUserError())
      }
      return
    }

    yield put(loadUserError())
  } catch (error) {
    yield put(loadUserError())
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(AUTH_LOAD_USER, loadUserOnSaga)
}

export default authSaga
